/**
 * Mixin to add standardized JSURL handling to a Panel app
 */
import {parseJsUrl, serializeJsUrl} from './util/url';

export interface JSURLMixable {
  handleInvalidURLParams(): any;
  handleURLParamsUpdate(_parsedURL): any;
  jsURLPrefix?(): string;
}

export const JSURLMixin = (superclass) =>
  class extends superclass {
    /**
     * Panel route handler for JSURLized data. Attempts to repair common
     * link malformations by email clients. Expects component to implement
     * handleURLParamsUpdate() and handleInvalidURLParams(), and optionally
     * specify jsURLPrefix() if they wish to prefix url updates.
     */
    handleJSURLRoute(stateUpdate = {}, rawJsURL) {
      const jsUrlInfo = parseJsUrl(rawJsURL);
      if (jsUrlInfo.valid) {
        if (jsUrlInfo.correctedUrl !== rawJsURL) {
          const url = `${this._getUrlPrefix()}${jsUrlInfo.correctedUrl}`;
          history.replaceState(null, ``, url);
          stateUpdate = {...stateUpdate, $fragment: jsUrlInfo.correctedUrl};
        }

        return {...stateUpdate, ...this.handleURLParamsUpdate(jsUrlInfo.data)};
      } else {
        this.navigate(``, {...stateUpdate, ...this.handleInvalidURLParams()});
      }
    }

    /**
     * Serialize data and put in URL hash. Removes hash altogether if data is null/undefined.
     * @param {Object} urlData - data to serialize on URL
     */
    updateJSURL(urlData, pushState = false) {
      const url = `${this._getUrlPrefix()}${serializeJsUrl(urlData)}`;

      if (pushState) {
        history.pushState(null, ``, url);
      } else {
        history.replaceState(null, ``, url);
      }
    }

    _getUrlPrefix(): string {
      return this.jsURLPrefix ? this.jsURLPrefix() : `#`;
    }
  };
